import axios from "axios";
import { REFRESH_TOKEN_URL } from "../../utils/api-ends";
import { BACKEND_HOST } from "../../config";


let isRefreshing = false;
let failedQueue = [];

// This function will be used later in this file.
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};


async function addRequestToQueue(originalRequest) {
    return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
    })
    .then((token) => {
        originalRequest.headers["Authorization"] = "Bearer " + token;
        originalRequest.headers.Authorization = "Bearer " + token;
        return axios(originalRequest);
    })
    .catch((err) => {
        return Promise.reject(err);
    });
}

async function refreshToken(originalRequest, auth_tk) {
    return new Promise(function (resolve, reject) {
        axios({
            url: REFRESH_TOKEN_URL.url,
            method: "POST",
            data: { refresh: auth_tk.refresh },
        })
        .then((res) => res.data)
        .then((res) => {
            const data = {
                access: res.access,
                refresh: auth_tk.refresh,
            };

            localStorage.setItem("auth_token", JSON.stringify(data));
            axios.defaults.headers.common["Authorization"] = "Bearer " + data.access;
            originalRequest.headers["Authorization"] = "Bearer " + data.access;

            processQueue(null, data.access);
            resolve(axios(originalRequest));
        })
        .catch((err) => {
            // May be this part isn't calling ,as it's axios interceptor for error msg.
            processQueue(err, null);
            reject(err);
        })
        .finally(() => {
            isRefreshing = false;
        });
    });
}

export function responseInterceptor(auth_tk) {
    axios.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
            
            // Invalid or expired so consider this user as logged out and redirect to login/home page.
            if (BACKEND_HOST+REFRESH_TOKEN_URL.url === error?.config?.url) {
                localStorage.removeItem("auth_token");
                window.location.href = `/`;
            }            
            
            const originalRequest = error.config;
    
            // If the error is related to unauthorized and have auth tk
            if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry && auth_tk) {
                
                /** Though we're trying to get the refresh token already, for any other request 
                    which try to happen together we hold them/add them in the queue.
                **/
                if (isRefreshing) addRequestToQueue(originalRequest);
    
                originalRequest._retry = true;
                isRefreshing = true;
    
                /** Make request to get new access token with the refresh token we've.
                    When success means we get new token and we add it in our localStorage as well as 
                    set as our default auth token with each axios request and continue all the hold/queued process 
                    including the first one(for what we started looking for new token using refresh token)
                **/
                refreshToken(originalRequest, auth_tk)
            }
    
            return Promise.reject(error);
        }
    )
}



